<template>
    <div class="footer__copyright">
        <span>Copyright © {{ year }} {{ appName }}. All rights reserved.</span>
    </div>
</template>

<script>
import config from '@/config'
export default {
    data() {
        return {
            appName: config.appName,
            year: new Date().getFullYear(),
        };
    },
};
</script>
